import { getCDNUrl } from './CDNUrl';

const dir = 'home';

export const ClearfacePreviewImage = getCDNUrl(
  'service',
  'clearface-preview.png',
);
export const BabyfacePreviewImage = getCDNUrl(dir, 'babyface_preview.jpg');

// export const MainCarouselPc = [getCDNUrl(dir, `home_main_banner_0.png`)];
export const MainCarouselPc = [];